import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useModalStore } from '../../../stores/modalStore'
import { useProfile } from '../../../utils/hooks'

interface IMailToProps {
  email?: string
  subject?: string
  body?: string
  bcc?: string
  caseEmailContext?: { caseId: string; processingId?: string }
}

const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

const MailTo: React.FC<IMailToProps> = ({
  email,
  subject = '',
  body = '',
  bcc = '',
  caseEmailContext
}) => {
  const { t } = useTranslation('common')
  const { me } = useProfile()
  const openSendEmailAction = useModalStore(state => state.openSendEmailAction)
  const validEmail = email ? isValidEmail(email) : false
  const opensCaseEmailModal = Boolean(me?.caseEmailsEnabled && caseEmailContext?.caseId)

  const onClick = () => {
    if (opensCaseEmailModal && caseEmailContext) {
      openSendEmailAction({ ...caseEmailContext, initialToAddress: email })
      return
    }
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}&bcc=${bcc}`
  }

  return (
    <Tooltip title={t(opensCaseEmailModal ? 'sendCaseEmail' : 'openEmailClient')} placement="top">
      <IconButton size="small" onClick={onClick} disabled={!validEmail}>
        <MailOutlineIcon />
      </IconButton>
    </Tooltip>
  )
}

export default MailTo
